import { useContext, useEffect } from 'react'
import { ConferenceContext } from 'contexts/conference'
import { ConferenceParticipant } from 'contexts/conference/types'

const useRenderVideo = (participant?: ConferenceParticipant | undefined, div?: HTMLDivElement | null, virtualBackgroundEnabled?: boolean | null): void => {
    const conference = useContext(ConferenceContext)
    useEffect(() => {
        if (conference.status === 'session-joined' && div && participant) {
            const container = document.getElementById('video-player-container')?.getBoundingClientRect()
            const containerLeft = container ? container.left : 0
            const containerTop = container ? container.top : 0
            const bounds = div.getBoundingClientRect()

            void conference.rtcSession.setVideoFrame(participant, {
                left: bounds.x - containerLeft,
                top: bounds.y - containerTop,
                height: bounds.height,
                width: bounds.width
            })
        }
    }, [conference.participants, div, conference.speakers, conference.videoPlayerSize])
}

export { useRenderVideo }
